import axios, { getData } from 'lib/axios'

export const getAnnouncements = async (page = 1, perPage = 12) => {
    return axios.get('/announcements', { params: { page, per_page: perPage } }).then(getData)
}

export const getAnnouncementById = async (id) => {
    return axios.get(`/announcements/${id}`).then(getData)
}

export const getAnnouncementDepartments = async () => {
    return axios.get('/announcements/departments').then(getData)
}

export const createAnnouncement = async (payload) => {
    const formData = new FormData()

    formData.append('title', payload.title)
    formData.append('body', payload.body)
    formData.append('target_type', payload.target_type) // 'all' or 'department'

    if (payload.target_type === 'department' && Array.isArray(payload.target_ids)) {
        payload.target_ids.forEach((id, i) => {
            formData.append(`target_ids[${i}]`, id)
        })
    }

    if (Array.isArray(payload.attachments)) {
        payload.attachments.forEach((file) => {
            formData.append('attachments[]', file)
        })
    }

    return axios.post('/admin/announcements', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(getData)
}

export const updateAnnouncement = async (id, payload) => {
    const formData = new FormData()

    formData.append('title', payload.title)
    formData.append('body', payload.body)
    formData.append('target_type', payload.target_type)

    if (payload.target_type === 'department' && Array.isArray(payload.target_ids)) {
        payload.target_ids.forEach((deptId, i) => {
            formData.append(`target_ids[${i}]`, deptId)
        })
    }

    if (Array.isArray(payload.remove_attachment_ids)) {
        payload.remove_attachment_ids.forEach((attachId, i) => {
            formData.append(`remove_attachment_ids[${i}]`, attachId)
        })
    }

    if (Array.isArray(payload.attachments)) {
        payload.attachments.forEach((file, i) => {
            formData.append(`attachments[${i}]`, file)
        })
    }

    return axios.post(`/admin/announcements/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(getData)
}

export const deleteAnnouncement = async (id) => {
    return axios.delete(`/admin/announcements/${id}`).then(getData)
}